import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bc16c9da&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=bc16c9da&prod&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=bc16c9da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc16c9da",
  null
  
)

export default component.exports